import React, { Component, Fragment } from 'react'

export default class Footer extends Component {

    renderFooterItems(mobile) {
        const result = mobile
            ? (<Fragment>
                <a
                    className="d-block text-decoration-none white mb-1"
                    data-toggle="collapse"
                    href="#blogDoBeduka" aria-controls="#blogDoBeduka">
                    Blog do Beduka
                    <span className="float-right white" ></span>
                </a>
                <div className="collapse show pl-2" id="blogDoBeduka">
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/materias/"
                        target="_BLANK" rel="noopener noreferrer">
                        Matérias
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/exercicios/"
                        target="_BLANK" rel="noopener noreferrer">
                        Exercícios
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/dicas/cursos/"
                        target="_BLANK" rel="noopener noreferrer">
                        Cursos
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/dicas/faculdades/"
                        target="_BLANK" rel="noopener noreferrer">
                        Faculdades
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/dicas/vestibulares/"
                        target="_BLANK" rel="noopener noreferrer">
                        Vestibulares
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/dicas/profissoes/"
                        target="_BLANK" rel="noopener noreferrer">
                        Profissões
                    </a>
                </div>
                <a
                    className="d-block text-decoration-none white mb-1"
                    data-toggle="collapse"
                    href="#programasDoGoverno"
                    aria-controls="#programasDoGoverno">
                    Programas do Governo
                    <span className="float-right white" ></span>
                </a>
                <div className="collapse show pl-2" id="programasDoGoverno">
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/enem/guia-completo-enem/tudo-sobre-o-enem/"
                        target="_BLANK" rel="noopener noreferrer">ENEM</a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/sisu/como-funciona-sisu/"
                        target="_BLANK" rel="noopener noreferrer">SISU</a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/guia-completo-do-prouni/"
                        target="_BLANK" rel="noopener noreferrer">PROUNI</a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/guia-completo-do-fies/"
                        target="_BLANK" rel="noopener noreferrer">FIES</a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/dicas/encceja/"
                        target="_BLANK" rel="noopener noreferrer">ENCCEJA</a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/dicas/pronatec/"
                        target="_BLANK" rel="noopener noreferrer">PRONATEC</a>
                </div>
                <a
                    className="d-block text-decoration-none white mb-1"
                    data-toggle="collapse"
                    href="#melhoresFaculdades"
                    aria-controls="#melhoresFaculdades">
                    Melhores Faculdades
                    <span className="float-right white" ></span>
                </a>
                <div className="collapse show pl-2" id="melhoresFaculdades">
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/cursos/melhores-faculdades-medicina-veterinaria/"
                        target="_BLANK" rel="noopener noreferrer">
                        Medicina Veterinária
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/cursos/melhores-faculdades-publicas-medicina/"
                        target="_BLANK" rel="noopener noreferrer">
                        Medicina - Públicas
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/cursos/melhores-faculdades-particulares-medicina/"
                        target="_BLANK" rel="noopener noreferrer">
                        Medicina - Particulares
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/cursos/melhores-faculdades-particulares-direito/"
                        target="_BLANK" rel="noopener noreferrer">
                        Direito - Particulares
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/cursos/melhores-cursos-engenharia-civil-brasil/"
                        target="_BLANK" rel="noopener noreferrer">
                        Engenharia Civil
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/cursos/melhores-faculdades-odontologia-brasil/"
                        target="_BLANK" rel="noopener noreferrer">
                        Odontologia
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/cursos/melhores-faculdades-administracao-brasil/"
                        target="_BLANK" rel="noopener noreferrer">
                        Administração
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/cursos/melhor-universidade-arquitetura-brasil/"
                        target="_BLANK" rel="noopener noreferrer">
                        Arquitetura
                    </a>
                </div>

                <a
                    className="d-block text-decoration-none white mb-1"
                    data-toggle="collapse"
                    href="#produtosGratuitos"
                    aria-controls="#produtosGratuitos">
                    Veja também
                    <span className="float-right white"></span>
                </a>
                <div className="collapse show pl-2" id="produtosGratuitos">
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://beduka.com/blog/dicas/enem-dicas/plano-de-estudos-gratuito/"
                        target="_BLANK" rel="noopener noreferrer">
                        Plano de Estudos Enem <span className="bdk-fs-small-3 footer-new bg-white p-1 radius-2">NOVO</span>
                    </a>
                    <a
                        className="d-block text-decoration-none bdk-fs-small-2 white mb-1"
                        href="https://www.youtube.com/watch?v=RLzFdHHNNIA&list=PLglul53l0mWiFlK1vtgYBHdGnrW5wBDI7"
                        target="_BLANK" rel="noopener noreferrer">
                        Beduka Profissões - Vídeos
                    </a>
                </div>

                <div className="mobile-social-media-icons mt-3 py-3 border-top-white">
                    <a href="https://www.facebook.com/beduka.buscadordefaculdades/" target="_BLANK" rel="noopener noreferrer" className="d-flex flex-column justify-content mr-3 blue-accent-2">
                        <i className="ficon-facebook bg-white circle p-2 fa-stack-1x"></i>
                    </a>
                    <a href="https://www.instagram.com/beduka_oficial/" target="_BLANK" rel="noopener noreferrer" className="d-flex flex-column justify-content mr-3 blue-accent-2">
                        <i className="ficon-instagram bg-white circle p-2 fa-stack-1x"></i>
                    </a>
                    <a href="https://www.youtube.com/channel/UCf_H9euu8wlDM-mqB9FnUag/featured" target="_BLANK" rel="noopener noreferrer" className="d-flex flex-column justify-content blue-accent-2">
                        <i className="ficon-youtube-play bg-white circle p-2 fa-stack-1x"></i>
                    </a>
                </div>

                <div className="mt-1 border-bottom-white">
                    <a href="/sobre" target="_BLANK" rel="noopener noreferrer" className="d-block text-decoration-none mb-0 white">Sobre o Beduka</a>
                    <a href="/termos-de-uso" target="_BLANK" rel="noopener noreferrer" className="d-block text-decoration-none mb-0 white">Termos de Uso</a>
                    <a href="/politica-de-privacidade" target="_BLANK" rel="noopener noreferrer" className="d-block text-decoration-none mb-2 white">Politica de Privacidade</a>
                </div>

                <p className="text-center mt-3 mb-0 white">Beduka © {(new Date().getFullYear())}</p>
                <p className="text-center mb-0 white">CNPJ 28.173.645/0001-45</p>
            </Fragment>)
            : (<Fragment>
                <div className="columns border-bottom-white mb-3 py-3">
                    <div className="blog-related">
                        <h3 className="white mb-2">Blog do Beduka</h3>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/materias/"
                            target="_BLANK" rel="noopener noreferrer">
                            Matérias
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/exercicios/"
                            target="_BLANK" rel="noopener noreferrer">
                            Exercícios
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/dicas/cursos/"
                            target="_BLANK" rel="noopener noreferrer">
                            Cursos
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/dicas/faculdades/"
                            target="_BLANK" rel="noopener noreferrer">
                            Faculdades
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/dicas/vestibulares/"
                            target="_BLANK" rel="noopener noreferrer">
                            Vestibulares
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/dicas/profissoes/"
                            target="_BLANK" rel="noopener noreferrer">
                            Profissões
                        </a>
                    </div>
                    <div className="government-programs">
                        <h3 className="white mb-2">Programas do Governo</h3>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/enem/guia-completo-enem/tudo-sobre-o-enem/"
                            target="_BLANK" rel="noopener noreferrer">ENEM</a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/sisu/como-funciona-sisu/"
                            target="_BLANK" rel="noopener noreferrer">SISU</a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/guia-completo-do-prouni/"
                            target="_BLANK" rel="noopener noreferrer">PROUNI</a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/guia-completo-do-fies/"
                            target="_BLANK" rel="noopener noreferrer">FIES</a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/dicas/encceja/"
                            target="_BLANK" rel="noopener noreferrer">ENCCEJA</a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/dicas/pronatec/"
                            target="_BLANK" rel="noopener noreferrer">PRONATEC</a>
                    </div>
                    <div className="best-courses">
                        <h3 className="white mb-2">Melhores Faculdades</h3>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/cursos/melhores-faculdades-medicina-veterinaria/"
                            target="_BLANK" rel="noopener noreferrer">
                            Medicina Veterinária
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/cursos/melhores-faculdades-publicas-medicina/"
                            target="_BLANK" rel="noopener noreferrer">
                            Medicina - Públicas
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/cursos/melhores-faculdades-particulares-medicina/"
                            target="_BLANK" rel="noopener noreferrer">
                            Medicina - Particulares
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/cursos/melhores-faculdades-particulares-direito/"
                            target="_BLANK" rel="noopener noreferrer">
                            Direito - Particulares
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/cursos/melhores-cursos-engenharia-civil-brasil/"
                            target="_BLANK" rel="noopener noreferrer">
                            Engenharia Civil
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/cursos/melhores-faculdades-odontologia-brasil/"
                            target="_BLANK" rel="noopener noreferrer">
                            Odontologia
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/cursos/melhores-faculdades-administracao-brasil/"
                            target="_BLANK" rel="noopener noreferrer">
                            Administração
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/cursos/melhor-universidade-arquitetura-brasil/"
                            target="_BLANK" rel="noopener noreferrer">
                            Arquitetura
                        </a>
                    </div>
                    <div className="our-other-products">
                        <h3 className="white mb-2">Veja também</h3>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://beduka.com/blog/dicas/enem-dicas/plano-de-estudos-gratuito/"
                            target="_BLANK" rel="noopener noreferrer">
                            Plano de Estudos Enem <span className="bdk-fs-small-3 footer-new bg-white p-1 radius-2">NOVO</span>
                        </a>
                        <a
                            className="d-block text-decoration-none bdk-fs-small-1 white mb-2"
                            href="https://www.youtube.com/watch?v=RLzFdHHNNIA&list=PLglul53l0mWiFlK1vtgYBHdGnrW5wBDI7"
                            target="_BLANK" rel="noopener noreferrer">
                            Beduka Profissões - Vídeos
                        </a>
                    </div>
                </div>
                <div className="social-media-and-about">
                    <div className="d-flex flex-column justify-content">
                        <p className="bdk-fs-small-1 white mb-1">Beduka © {(new Date().getFullYear())}</p>
                        <p className="bdk-fs-small-1 white mb-1">CNPJ 28.173.645/0001-45</p>
                    </div>
                    <div className="social-media-icons">
                        <a href="https://www.facebook.com/beduka.buscadordefaculdades/" target="_BLANK" rel="noopener noreferrer" className="d-flex flex-column justify-content mr-3 my-auto blue-accent-2">
                            <i className="ficon-facebook bg-white circle p-2 fa-stack-1x"></i>
                        </a>
                        <a href="https://www.instagram.com/beduka_oficial/" target="_BLANK" rel="noopener noreferrer" className="d-flex flex-column justify-content mr-3 my-auto blue-accent-2">
                            <i className="ficon-instagram bg-white circle p-2 fa-stack-1x"></i>
                        </a>
                        <a href="https://www.youtube.com/channel/UCf_H9euu8wlDM-mqB9FnUag/featured" target="_BLANK" rel="noopener noreferrer" className="d-flex flex-column justify-content mr-3 my-auto blue-accent-2">
                            <i className="ficon-youtube-play bg-white circle p-2 fa-stack-1x"></i>
                        </a>
                    </div>
                    <div className="d-flex flex-column justify-content">
                        <a className="bdk-fs-small-1 white mb-1 text-decoration-none" href="/sobre" target="_BLANK" rel="noopener noreferrer">Sobre o Beduka</a>
                        <a className="bdk-fs-small-1 white mb-1 text-decoration-none" href="/politica-de-privacidade" target="_BLANK" rel="noopener noreferrer">Política de Privacidade</a>
                        <a className="bdk-fs-small-1 white mb-1 text-decoration-none" href="/termos-de-uso" target="_BLANK" rel="noopener noreferrer">Termos de Uso</a>
                    </div>
                </div>
            </Fragment>)

        return result;
    }



    render() {
        // console.log(window.window.location.pathname);
        return (
            <footer className="bdk-footer py-3">
                <div className="show-for-medium">
                    {this.renderFooterItems(false)}
                </div>
                <div className="hide-for-medium">
                    {this.renderFooterItems(true)}
                </div>
            </footer>
        )
    }
}